<template>
<div id="wrapper" @click.self="hide">
  <div id="content">
    <div class="close" @click="hide">&times;</div>
    <Markdown :source="content"></Markdown>
  </div>
</div>
</template>

<script>
import Markdown from "vue3-markdown-it";
export default {
  name: "about",
  components: {Markdown},
  computed: {
    content(){
      return this.$store.getters["aboutText"];
    }
  },
  methods:{
    hide(){
      this.$emit("hide");
    }
  }
}
</script>

<style scoped lang="less">
@import (reference) "../assets/less/colors";

:deep(h2){
  color: @red;
}
:deep(p), :deep(li){
  line-height: 1.5;
  font-size: 1.1rem;
}
#wrapper{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: fadeout(@black, 50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
#content{
  background: @white;
  padding: 1.5em;
  width: 50em;
  max-width: 90%;
  max-height: 85%;
  overflow: auto;
  position: relative;
}
.close{
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 10px;
  top: 10px;
  width: 1.5rem;
  height: 1.5rem;
  color: @white;
  background: @red;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
}
</style>
